export enum SubscriptionTier {
  FREE = 'free',
  PRO = 'pro',
  ENTERPRISE = 'enterprise',
}

export interface SubscriptionFeatures {
  maxMundus: number;
  maxAgents: number;
  maxMetrics: number;
  aiAnalysis: boolean;
  emailReports: boolean;
  prioritySupport: boolean;
  customBranding: boolean;
  apiAccess: boolean;
}

export interface TierInfo {
  tier: SubscriptionTier;
  name: string;
  price: number; // In cents
  interval: 'month' | 'year';
  features: SubscriptionFeatures;
}

export interface Subscription {
  id: string;
  userId: string;
  tier: SubscriptionTier;
  status: 'active' | 'canceled' | 'past_due' | 'trialing';
  currentPeriodStart: Date;
  currentPeriodEnd: Date;
  cancelAtPeriodEnd: boolean;
  cancelAt?: Date;
  stripeSubscriptionId?: string;
  stripeCustomerId?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface ResourceLimit {
  resourceType: 'mundus' | 'agents' | 'metrics';
  current: number;
  limit: number;
  canCreate: boolean;
  percentage: number;
}

export interface FeatureAccess {
  feature: string;
  hasAccess: boolean;
}
